import script from "./Iframe.vue?vue&type=script&setup=true&lang=js"
export * from "./Iframe.vue?vue&type=script&setup=true&lang=js"

import "./Iframe.vue?vue&type=style&index=0&id=31b2d388&lang=css"

const __exports__ = script;

export default __exports__